import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "pi pi-angle-down"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-angle-up"
}
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = {
  key: 0,
  class: "pi pi-angle-down"
}
const _hoisted_6 = {
  key: 1,
  class: "pi pi-angle-up"
}
const _hoisted_7 = { class: "menu_footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseRegistrationModal = _resolveComponent("CourseRegistrationModal")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PanelMenu = _resolveComponent("PanelMenu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: _normalizeClass('menu_container' + (_ctx.window.innerWidth > 750 ? ' show' : ''))
  }, {
    content: _withCtx(() => [
      _createVNode(_component_CourseRegistrationModal, { ref: "courseRegistrationModal" }, null, 512),
      _createVNode(_component_PanelMenu, {
        model: _ctx.items,
        class: "panel_menu",
        multiple: "",
        expandedKeys: _ctx.expandedKeys,
        "onUpdate:expandedKeys": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expandedKeys) = $event)),
          _ctx.updateExpandedKeys
        ]
      }, {
        item: _withCtx(({ item, props }) => [
          (item.route)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: item.route,
                custom: ""
              }, {
                default: _withCtx(({ href, navigate, isActive }) => [
                  _createElementVNode("a", _mergeProps({ href: href }, props.action, {
                    onClick: navigate,
                    class: isActive ? 'menu_item router-active': 'menu_item' ,
                    "aria-hidden": "false"
                  }), [
                    _createElementVNode("span", {
                      class: _normalizeClass(item.icon+' p-menu-item-icon')
                    }, null, 2),
                    _createElementVNode("span", {
                      class: "label",
                      style: _normalizeStyle(item.items ? 'font-weight: bold': '')
                    }, _toDisplayString(item.label), 5),
                    (item.items && item.expandable && !_ctx.expandedKeys[item.key])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                      : _createCommentVNode("", true),
                    (item.items && item.expandable && _ctx.expandedKeys[item.key])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                      : _createCommentVNode("", true)
                  ], 16, _hoisted_1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("a", _mergeProps({
                key: 1,
                href: item.url,
                target: item.target
              }, props.action, {
                class: "menu_item",
                "aria-hidden": "false"
              }), [
                _createElementVNode("span", {
                  class: _normalizeClass(item.icon+' p-menu-item-icon')
                }, null, 2),
                _createElementVNode("span", {
                  class: "label",
                  style: _normalizeStyle(item.items ? 'font-weight: bold': '')
                }, _toDisplayString(item.label), 5),
                (item.items && item.expandable && !_ctx.expandedKeys[item.key])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                  : _createCommentVNode("", true),
                (item.items && item.expandable && _ctx.expandedKeys[item.key])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                  : _createCommentVNode("", true)
              ], 16, _hoisted_4))
        ]),
        _: 1
      }, 8, ["model", "expandedKeys", "onUpdate:expandedKeys"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          icon: _ctx.themeStore.getTheme === 'dark' ? 'pi pi-sun': 'pi pi-moon',
          severity: "contrast",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.themeStore.toggleTheme()))
        }, null, 8, ["icon"]),
        (_ctx.authStore.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "pi pi-sign-out",
              onClick: _ctx.authStore.logout,
              fluid: true,
              severity: "danger"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}